<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'1250px'"
    :classDialog="'dialogTransferHandling'"
    :offsetTop="'8vh'"
    :appendToBody="true"
    :modalAppendToBody="true"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="title flex-row">
        <h2 class="dialogTitle">Chọn danh sách lãnh đạo</h2>
      </div>
      <!-- body -->

      <el-row class="dialog-body margin-0" :gutter="24">
        <el-col :span="12" class="list-collapse__transfer">
          <!--          <h4 class="margin-bottom-10">Danh sách đã chọn</h4>-->
          <div class="flex-row flex__left margin-bottom-10">
            <el-input
              prefix-icon="el-icon-search"
              size="medium"
              placeholder="Tìm kiếm theo tên/email/đơn vị/chức vụ"
              @keydown.enter.exact.native="searchTree"
              v-model="query"
            ></el-input>
          </div>
          <VuePerfectScrollbar class="scroll-area scroll-area-height_90">
            <el-tree
              :data="roots"
              :filter-node-method="filterTree"
              ref="departmentTree"
              class="filter-tree"
              default-expand-all
            >
              <div
                class="custom-tree-node flex-row flex__between width__100"
                slot-scope="{ node, data }"
              >
                <div class="field-1">
                  <span>
                    <el-checkbox
                      v-model="data.checked"
                      size="medium"
                      @change="checkedChangeEvent(data)"
                    >
                      <span
                        v-if="
                          data.nodeType ===
                          DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                        "
                      >
                        &nbsp;
                        <span class="font-weight__bold font-size__medium">
                          {{ data.userDeptRole.fullName }}
                        </span>
                        <span
                          class="font-size__small font-italic font-size__medium"
                        >
                          ({{ data.userDeptRole.positionName }})
                        </span>
                      </span>
                      <span v-else class="font-size__medium"
                        >&nbsp;{{ getNodeLabel(data) }}</span
                      >
                    </el-checkbox>
                  </span>
                </div>
              </div>
            </el-tree>
          </VuePerfectScrollbar>
        </el-col>
        <el-col :span="12" class="display-list__selected">
          <!-- chuyen xu ly -->
          <div :class="['list-selected']">
            <!-- title -->
            <div class="header">
              <div class="flex-row flex__between">
                <h5 class="title margin-0">Danh sách đã chọn</h5>
              </div>
            </div>
            <!-- end_title -->
            <div class="body">
              <div class="list-filter">
                <VuePerfectScrollbar
                  class="scroll-list-user"
                  :settings="perfectScrollbarSetting"
                >
                  <div
                    v-for="(item, index) in groups"
                    :key="index"
                    class="selected-user flex-row flex__between"
                  >
                    <div class="title flex-row flex__left padding-right-10">
                      <div class="clickable margin-right-10">
                        {{ index + 1 }}.
                      </div>
                      <div
                        class="flex-row flex__left"
                        v-if="item.type === 'item'"
                      >
                        <div class="info">
                          <p class="people__name">
                            {{ item.data.data.userDeptRole.fullName }}
                          </p>
                          <p class="people__position margin-0">
                            {{ item.data.data.userDeptRole.positionName }} -
                            {{ item.data.data.userDeptRole.deptName }}
                          </p>
                        </div>
                      </div>
                      <div class="flex-row flex__left" v-else>
                        <div class="avt"></div>
                        <div class="info">
                          <p class="people__name">
                            {{ getLabelForFilter(item.filter) }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="list-checkbox flex-row flex__right margin-right-10"
                    >
                      <i
                        class="icon-close color__red clickable font-size__medium el-icon-circle-close"
                        @click="removeSelectedGroup(item)"
                      ></i>
                    </div>
                  </div>
                </VuePerfectScrollbar>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="submit">
          <i :class="['fas fa-check-circle font-size__small']"></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fal fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import constants from "../../../constants";
import buildShortNameFilter from "../../../filters/buildShortNameFilter.js";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import handlersTreeMixin from "../../../mixins/handlersTreeMixin";
import h from "../../../services/h";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import utils from "../../../services/utils";
import CustomDialog from "../../common/custom-dialog";

export default {
  name: "lichtuan-select-actors-dialog",
  mixins: [handlersTreeMixin],
  filters: { buildShortNameFilter },
  props: [
    "isOpen",
    "deptId", //cap quy trình được chọn;
    "selectedActors",
  ],
  components: {
    CustomDialog,
    VuePerfectScrollbar,
  },

  data() {
    return {
      DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
      DEPARTMENT: constants.DEPARTMENT,
      query: null,
      settings: { maxScrollbarLength: 750 },
      selectedHandlersData: [],
      groups: [],
      groupFilters: [],
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    isLanhDao() {
      return (
        this.userDeptRole &&
        this.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO
      );
    },
  },

  created() {
    this.initGroupFilters()
      .then(() => this.loadActors())
      .then(() => this.buildNodes())
      .then(() => this.markCheckedForSelectedToUsers());
  },

  methods: {
    findTreeNodeByUserDeptRoleId(data, hcCaseCalendarUser) {
      if (
        data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
      ) {
        return data.userDeptRole.id === hcCaseCalendarUser.userDeptRoleId ||
          (!hcCaseCalendarUser.userDeptRoleId &&
            hcCaseCalendarUser.userId === data.userDeptRole.userId)
          ? data
          : null;
      } else {
        let children = data.children;
        if (children && children.length) {
          for (let index = 0; index < children.length; index++) {
            let child = children[index];
            let result = this.findTreeNodeByUserDeptRoleId(
              child,
              hcCaseCalendarUser
            );
            if (result) return result;
          }
        }
        return null;
      }
    },

    markCheckedForSelectedToUsers() {
      let selectedActors = this.selectedActors;
      if (selectedActors && selectedActors.length) {
        h.each(this.roots, (root) =>
          this.markChecked_(
            root,
            (data) =>
              data.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
              h.exists(
                selectedActors,
                (item) =>
                  item.userDeptRoleId === data.userDeptRole.id ||
                  (!item.userDeptRoleId &&
                    item.userId === data.userDeptRole.userId) //TH này là để tương thích ngược vs dữ liệu cũ;
              )
          )
        );
      }

      //collect những node đã được chọn theo thứ tự
      this.selectedHandlersData = [];
      h.each(selectedActors, (selectedActor) => {
        let selectedActorNode;
        if (this.roots && this.roots.length) {
          for (let index = 0; index < this.roots.length; index++) {
            selectedActorNode = this.findTreeNodeByUserDeptRoleId(
              this.roots[index],
              selectedActor
            );
            if (selectedActorNode) {
              this.selectedHandlersData.push({ data: selectedActorNode });
              return;
            }
          }
        }
      });
      //populate lại dữ liệu hiển thị;
      this.groupActors();
    },

    markChecked_(data, isShouldCheckFn) {
      if (!data.checked) {
        let shouldCheck = isShouldCheckFn(data);
        if (shouldCheck) {
          this.$set(data, "checked", true);
          if (
            data.nodeType !== constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
          )
            this.checkedAllChildren(data, data.checked);
        } else {
          h.each(data.children, (child) =>
            this.markChecked_(child, isShouldCheckFn)
          );
          if (
            data.nodeType !== constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
          ) {
            if (!h.exists(data.children, (child) => !child.checked))
              this.$set(data, "checked", true);
          }
        }
      }
    },

    getLabelForFilter(filter) {
      return utils.getLabelForActorGroupFilter(filter);
    },

    initGroupFilters() {
      return (this.deptId === constants.TCT_DEPT_ID
        ? utils.initGroupFilters((actor) => {
            return actor.data.userDeptRole.id;
          })
        : Promise.resolve([])
      ).then((groupFilters) => (this.groupFilters = groupFilters));
    },

    addOrRemoveToSelectedHandlers(data) {
      let checked = data.checked;
      let index = h.indexOf(
        this.selectedHandlersData,
        (item) => item.data === data
      );
      if (checked) {
        if (index === -1) this.selectedHandlersData.push({ data: data });
      } else {
        this.selectedHandlersData.splice(index, 1);
      }
    },

    getNodeLabel(node) {
      return utils.getNodeLabelForHandlersTree(node);
    },

    loadActors() {
      return userDeptRoleViewService
        .findAllForLichTuan(this.deptId)
        .then((response) => (this.userDeptRoleHandlers = response.data || []));
    },

    searchTree() {
      this.$refs.departmentTree.filter(this.query);
    },

    filterTree(value, data) {
      switch (data.nodeType) {
        case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          return utils.like(data.department.deptName, this.query);
        case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
          return utils.filterUserDeptRoleView(this.query, data.userDeptRole);
        default:
          return false;
      }
    },

    markCheckedForSelectedHandlers(data) {
      h.each(data.children, (child) =>
        this.markCheckedForSelectedHandlers(child)
      );
      if (data.isHandlerNode) {
        let nodeType = data.nodeType;
        let selectedHandler;
        switch (nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
            let department = data.department;
            selectedHandler = h.find(
              this.selectedHandlers,
              (item) =>
                item.stepType === constants.STEP.STEP_TYPE.DONVI &&
                department.id === item.department.id
            );
            break;
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            let userDeptRole = data.userDeptRole;
            selectedHandler = h.find(
              this.selectedHandlers,
              (item) =>
                item.stepType === constants.STEP.STEP_TYPE.CANHAN &&
                userDeptRole.id === item.userDeptRole.id
            );
            break;
          default:
            break;
        }
        if (selectedHandler) {
          this.$set(data, "checked", true);
          this.addOrRemoveToSelectedHandlers(data);
        }
      } else {
        let isAllChildNodesChecked = !h.exists(
          data.children,
          (child) => !child.checked
        );
        this.$set(data, "checked", isAllChildNodesChecked);
      }
    },

    removeFromSelectedHandlersData(item) {
      this.$set(item.data, "checked", false);
      this.addOrRemoveToSelectedHandlers(item.data);
      this.updateCheckedForParent(item.data);
    },

    removeSelectedGroup(group) {
      this.groups.splice(this.groups.indexOf(group), 1);
      let removeActors = [];
      switch (group.type) {
        case "group":
          removeActors = group.data;
          break;
        case "item":
          removeActors = [group.data];
          break;
      }
      h.each(removeActors, (actor) =>
        this.removeFromSelectedHandlersData(actor)
      );
    },

    updateCheckedForParent(data) {
      let parent = data.parent;
      if (!parent || parent.isHandlerNode) return;
      let currentCheckedState = parent.checked;
      let newCheckedState = !h.exists(
        parent.children,
        (child) => !child.checked
      );
      if (currentCheckedState !== newCheckedState) {
        this.$set(parent, "checked", newCheckedState);
        this.updateCheckedForParent(parent);
      }
    },

    checkedChangeEvent(data) {
      this.checkedChange(data);
      this.groupActors();
    },

    checkedChange(data) {
      let checked = data.checked;
      if (data.isHandlerNode) {
        let nodeType = data.nodeType;
        switch (nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            this.addOrRemoveToSelectedHandlers(data);
            break;
          default:
            break;
        }
      } else {
        this.checkedAllChildren(data, checked);
      }
      this.updateCheckedForParent(data);
    },

    checkedAllChildren(data, checked) {
      h.each(data.children, (child) => {
        let checkedState = child.checked || false;
        if (checkedState !== checked) {
          this.$set(child, "checked", checked);
          this.checkedChange(child);
        }
      });
    },

    submit() {
      let userDeptRoles = h.collect(
        this.selectedHandlersData,
        (actor) => actor.data.userDeptRole
      );

      if (!userDeptRoles || !userDeptRoles.length) {
        this.notify(
          "Lỗi",
          errorMessageFilter({
            errorCode: "hcCaseCalendar.leaders.required",
          }),
          "error",
          2000
        );
      } else {
        this.$emit("changed", { userDeptRoles: userDeptRoles });
      }
    },

    groupActors() {
      this.groups = utils.groupActors(
        this.selectedHandlersData,
        this.groupFilters
      );
    },
  },
};
</script>
<style scoped>
.title {
  width: 100%;
}

.list-checkbox {
  position: relative;
  margin-right: 10px;
}

.scroll-list-user {
  height: auto;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}

.list-checkbox .item {
  width: 90px;
  text-align: center;
  margin: 0;
}

.icon-close {
  position: absolute;
  right: -5px;
  font-size: 18px;
}

.dialog-body .display-list__selected .list-selected .header > div {
  width: 100%;
}

.dialog-body .display-list__selected .list-selected .body {
  padding: 0;
}

.dialogTransferHandling .dialog-body .list-collapse__transfer {
  display: flex;
  flex-direction: column;
}

.dialogTransferHandling .dialog-body .scroll-area-height_90 {
  height: 100%;
  margin-bottom: 0;
  margin-right: -13px;
}

.dialog-body .display-list__selected {
  height: 400px;
}

.dialogTransferHandling .dialog-body .display-list__selected .list-selected {
  height: 385px;
}

.dialog-body .display-list__selected .list-selected .header {
  padding-left: 10px;
  padding-right: 10px;
}

.dialog-body .display-list__selected .list-selected .body .list-filter {
  height: 100%;
}

/*.dialogTransferHandling .dialog-body .list-collapse__transfer {*/
/*  height: 405px;*/
/*}*/

/*.pScrollDialog {*/
/*  height: 405px!important;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/lichtuan-select-actors-dialog.vue